import { render, staticRenderFns } from "./nuxt-error.vue?vue&type=template&id=5eb69f1c"
import script from "./nuxt-error.vue?vue&type=script&lang=js"
export * from "./nuxt-error.vue?vue&type=script&lang=js"
import style0 from "./nuxt-error.vue?vue&type=style&index=0&id=5eb69f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports